import type { ColorsPalette } from '../components/ui/Design';
import { colors } from '../components/ui/Design';
import type { HEX } from '../types';

export const STYLE_CODE = 5;

export const getColorHex = (colorName: ColorsPalette, colorCode?: number): HEX => {
  const color = colors[colorName];

  if (colorCode === undefined) {
    return color.primary as HEX;
  }

  return color[colorCode] as HEX;
};
